import { OrderArgs, OrdersQueryKey } from "@/types/order-table";
import { useOrdersContext } from "@/contexts/orders-context";
import { useAppState } from "@/contexts/app-state";

// "orders" for now but this will be union of string literals
type QueryKeyTypes = "orders";

export const useQueryKeys = (type: QueryKeyTypes) => {
  const { pageNumber, sortBy, sortOrder } = useOrdersContext();
  const { context } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const departmentId = context?.athena?.departmentId ?? "3089";

  if (type === "orders")
    return ({
      user,
      filters,
      bucketName,
    }: Pick<OrderArgs, "user" | "filters" | "bucketName">): OrdersQueryKey => [
      "orders",
      user,
      {
        filters,
        pageNumber,
        pageSize: 10,
        practiceId,
        departmentId,
        bucketName,
        sortBy,
        sortOrder,
      },
    ];

  const _notgonnahappen: never = type;
  return _notgonnahappen;
};
